<template>
  <div class="pe_spinner">
    <div 
      v-if="type === 'cube'" 
      class="pe_cube"
    >
      <div class="pe_cube1"></div>
      <div class="pe_cube2"></div>
    </div>

    <div 
      v-if="type === 'circle'" 
      class="pe_circle"
    ></div>
  </div>

  
</template>


<script>
export default {
  props: ['type']
}
</script>

<style lang="scss">

.pe_spinner {

  .pe_circle, 
  .pe_cube {
    width: 55px;
    height: 55px;
    transform: translateZ(0);
  }

  .pe_circle {    
    text-indent: -9999em;
    border-radius: 50%;
    background: transparent;
    background: linear-gradient(to right, rgb(117, 117, 117) 10%, rgba(255, 255, 255, 0) 42%);
    position: relative;
    animation: load3 1.4s infinite linear;
      
    &:before {
      content: '';
      width: 50%;
      height: 50%;
      background: rgb(117, 117, 117);
      border-radius: 100% 0 0 0;
      position: absolute;
      top: 0;
      left: 0;
    }
    
    &:after {
      content: '';
      background: #ffffff;
      width: 75%;
      height: 75%;
      border-radius: 50%;
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }


  .pe_cube {      
    margin: 0px auto;
    position: relative;

    .pe_cube1, .pe_cube2 {
      background-color: rgb(117, 117, 117);
      width: 15px;
      height: 15px;
      position: absolute;
      top: 0;
      left: 0;
      
      -webkit-animation: sk-cubemove 1.8s infinite ease-in-out;
      animation: sk-cubemove 1.8s infinite ease-in-out;
    }

    .pe_cube2 {
      -webkit-animation-delay: -0.9s;
      animation-delay: -0.9s;
    }
  }

}


@keyframes sk-cubemove {
  25% { 
    transform: translateX(42px) rotate(-90deg) scale(0.5);
  } 50% { 
    transform: translateX(42px) translateY(42px) rotate(-179deg);
  } 50.1% { 
    transform: translateX(42px) translateY(42px) rotate(-180deg);
  } 75% { 
    transform: translateX(0px) translateY(42px) rotate(-270deg) scale(0.5);
  } 100% { 
    transform: rotate(-360deg);
  }
}

@keyframes load3 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>